import * as React from 'react';

import LocaleFormating from 'src/translation/localeFormating';

import './ECheckInvoices.scss';
import ECheckInvoiceTable from '../ECheckInvoiceTable';
import { IInvoiceEcheck } from '../../ECheckForm';

interface IECheckInvoicesProps {
  invoices: IInvoiceEcheck[];
  userAccount: string;
}

class ECheckInvoices extends React.Component<IECheckInvoicesProps, any> {
  private getTotalDue = () => {
    let total: number = 0;

    this.props.invoices.forEach(invoice => {
      total += Number(invoice.payment);
    });

    return total;
  };

  public render() {
    return (
      <div className="rp-echeck-invoices container-fluid">
        <div className="row rp-echeck-invoices-row">
          <div className="col-5 col-sm-6 d-flex justify-content-start">
            <h3 className="rp-echeck-invoices-title">Pay by e-check</h3>
          </div>
          <div className="col-7 col-sm-6">
            <h3 className="rp-echeck-invoices-amount">
              Total amount: {LocaleFormating.formatCurrency(this.getTotalDue())}
            </h3>
          </div>
        </div>
        <div className="row rp-echeck-invoices-table">
          <div className="col-2 rp-echeck-invoices-table-header">
            <h4>Invoice #</h4>
          </div>
          <div className="col-2 rp-echeck-invoices-table-header">
            <h4>Invoice Date</h4>
          </div>
          <div className="col-2 rp-echeck-invoices-table-header">
            <h4>Customer PO #</h4>
          </div>
          <div className="col-2 rp-echeck-invoices-table-header">
            <h4>Total amount</h4>
          </div>
          <div className="col-2 rp-echeck-invoices-table-header">
            <h4>Payment amount</h4>
          </div>
          <div className="col-2 rp-echeck-invoices-table-header">
            <h4>Reason for remaining balance</h4>
          </div>
        </div>
        {this.props.invoices.map(invoice => (
          <ECheckInvoiceTable
            invoice={invoice}
            userAccount={this.props.userAccount}
            key={invoice.invoiceNumber}
          />
        ))}
      </div>
    );
  }
}

export default ECheckInvoices;
